import {AUTH_KEY, STATUS} from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

import type {AuthType} from './types';
// authHelperCore is crypto-free (clearAuth needs no AES).
import {clearAuth} from '@jobseeker/common-core/utils/authHelperCore';
import authService from '@jobseeker/common-core/services/auth.service';
import {openUrl} from '@jobseeker/common-core/utils/common';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_AUTH}/`
);

const validate = async (path: string, options = {}): Promise<AuthType> => {
  try {
    const response: any = await axios.get(`${path}`, options);
    if (response[STATUS] === 200) {
      return {
        token: response.data?.[AUTH_KEY],
        userId: response.data?.['seekerId'],
        type: response.data?.['type'] || '',
      };
    }
    if (response?.type) {
      return response;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const refresh = async (path: string, headers?: object): Promise<any> => {
  const config = {
    withCredentials: true,
    retry: 3,
    retryDelay: 3000,
    ...headers,
  };

  try {
    const apiResponse = await axios.get(`${path}`, config);

    if (apiResponse[STATUS] === 200) {
      const token = apiResponse?.data?.token;
      if (token && token.length > 150 && token.split('.').length === 3) {
        return {
          token,
        };
      }

      return {};
    }
  } catch (error: any) {
    if (error?.response?.status === 406) {
      await authService.logOut('logout');
      if (typeof window !== 'undefined') {
        clearAuth();
      }
      openUrl('/', '_self');
    }
  }
};

const gladiatorService = {
  validate,
  refresh,
};

export default gladiatorService;
